import { normalizeApiUrl } from "./apiUrl";
import { getReturnTo } from "./authToken";

const DEMO_RETURN_PATH = "/flashlight-labs/available-activities";
const DEFAULT_RETURN_PATH = "/backpack";

export function isDemoAssessmentPath(pathname: string = window.location.pathname): boolean {
  return /^\/(reading|listening)\/demo(?:\/|$)/.test(pathname);
}

export function resolveAssessmentExitUrl(pathname: string = window.location.pathname): string {
  const appUrl = normalizeApiUrl(import.meta.env.REACT_APP_URL);
  const returnTo = getReturnTo()?.trim();
  const targetPath = returnTo
    ? `/${returnTo.replace(/^\/+/, "")}`
    : isDemoAssessmentPath(pathname)
      ? DEMO_RETURN_PATH
      : DEFAULT_RETURN_PATH;

  if (appUrl) {
    return `${appUrl}${targetPath}`;
  }

  return targetPath;
}

export function exitAssessment(pathname: string = window.location.pathname): void {
  window.location.assign(resolveAssessmentExitUrl(pathname));
}
